import { createSlice } from "@reduxjs/toolkit"

const environmentSlice = createSlice({
   name: "environment",
   initialState: {
      language: "fr",
      theme: null,
      prices: false,
   },
   reducers: {
      changeLanguage: (state, action) => {
         state.language = action.payload
      },
      changeTheme: (state, action) => {
         state.theme = action.payload
      },
      changePrices: (state, action) => {
         state.prices = action.payload
      },
   },
})

export const { changeLanguage, changeTheme, changePrices } =
   environmentSlice.actions
export default environmentSlice.reducer
